import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider, keepPreviousData } from '@tanstack/react-query';
import { AuthProvider } from './hooks/useAuth.jsx';
import App from './App';
import './index.css';
import ToastProvider from './components/ToastProvider';
import GoogleAnalytics from './components/GoogleAnalytics';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      placeholderData: keepPreviousData,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <GoogleAnalytics />
          <ToastProvider />
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
